<template lang="pug">
  .b-tile-dropdown(:style="{ top: verticalShift }")
    BaseOverlay(v-if="opened" @click.native="$emit('close')")
    ._items(:class="{ opened }")
      ._selected
        slot(name="selected")
      ._list(ref="list")
        slot(name="default")
</template>

<script>
import BaseOverlay from '@/components/BaseOverlay.vue';

export default {
  name: 'BaseTileDropdown',
  components: { BaseOverlay },
  props: {
    opened: Boolean,
  },
  data() {
    return {
      verticalShift: '0',
    };
  },
  watch: {
    opened(val) {
      if (!val) {
        this.verticalShift = '0';
        return;
      }

      this.$nextTick(() => {
        const bottomOfWindow = window.innerHeight;
        const bottomOfDropdown = this.$refs.list.getBoundingClientRect().bottom;

        const shift = bottomOfWindow - bottomOfDropdown;
        this.verticalShift = shift < 0 ? `${shift}px` : '0';
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tile-dropdown {
  position: relative;

  &__list {
    display: none;
  }

  &__items.opened {
    position: relative;
  }

  &__items.opened &__selected {
    position: relative;
    z-index: 1020;
  }

  &__items.opened &__list {
    position: absolute;
    top: 100%;
    display: grid;
    grid-row-gap: 10px;
    padding: 8px;
    left: -8px;
    background: white;
    border-radius: 0 0 6px 6px;
    z-index: 1020;
  }

  &__items.opened {
    &:after {
      display: block;
      content: '';
      position: absolute;
      top: -8px;
      left: -8px;
      right: -8px;
      bottom: 0;
      background: white;
      border-radius: 6px 6px 0 0 ;
      z-index: 1010;
    }
  }
}
</style>
